import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/background3.png";
import projImg4 from "../assets/img/background2.png";
import projImg5 from "../assets/img/background4.png";
import projImg6 from "../assets/img/background5.png";
import projImg7 from "../assets/img/background7.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
    const projects = [
        {
          title: "Into The Future",
          description: "Computer Vision and Web Development",
          imgUrl: projImg1,
          link : "https://github.com/mr-prometheus/Microsoft-Engage-Project",
        },
        {
          title: "Potato Leaf Disease Classification",
          description: "Deep Learning",
          imgUrl: projImg5,
          link : "https://github.com/mr-prometheus/Potato-Disease-Prediction-using-CNN",
        },
        {
          title: "Even More Fruitssss",
          description: "Deep Learning Classification ",
          imgUrl: projImg3,
          link : "https://github.com/mr-prometheus/More-Fruits-using-Deep-Learning",
        },
        {
          title: "Head Hat Detection",
          description: "Object Detection Computer Vision",
          imgUrl: projImg4,
          link : "https://github.com/mr-prometheus/Head-Hat-YOLO-Detection-",
        },
        {
          title: "Housing Price Prediction",
          description: "Machine Learning",
          imgUrl: projImg6,
          link : "https://github.com/mr-prometheus/Data-Science-Projects",
        },
        {
          title: "HandWritten Digit Classification",
          description: "Deep Learning Convolutional Neural Networks ",
          imgUrl: projImg7,
          link : "https://github.com/mr-prometheus/Neural-Network-from-Scratch",
        },
      ];
   return( <section className="project" id="project">
   <Container>
     <Row>
       <Col size={12}>
         <TrackVisibility>
           {({ isVisible }) =>
           <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
             <h2>Projects</h2>
              <Tab.Container id="projects-tabs" defaultActiveKey="first">
               <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                 
               </Nav>
               <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                 <Tab.Pane eventKey="first">
                   <Row>
                     {
                       projects.map((project, index) => {
                         return (
                           <ProjectCard
                             key={index}
                             {...project}
                             />
                         )
                       })
                     }
                   </Row>
                 </Tab.Pane>
               </Tab.Content>
             </Tab.Container>
           </div>}
         </TrackVisibility>
       </Col>
     </Row>
   </Container>
   <img className="background-image-right" src={colorSharp2}></img>
 </section>)
}